import { CURRENCY_SYMBOLS, TIMEFRAME_DISPLAY } from './constants';

export const formatDaysAfter = (days: number): string => {
  if (days === 0) return 'Reviewed the same day';
  if (days === 1) return 'Reviewed 1 day after the job';
  return `Reviewed ${days} days after the job`;
};

export const timeframeDisplay = (value: string | null | undefined): string => {
  if (!value) return '';
  return TIMEFRAME_DISPLAY[value] ?? '';
};

export const formatServicePrice = (
  service: Kudable.Service,
  currency: string | null,
): string | null => {
  if (!currency) return null;
  const currencySymbol = CURRENCY_SYMBOLS[currency] ?? currency;
  const { price_min, price_max } = service;
  if (price_min != null && price_max != null)
    return `${currencySymbol}${price_min} – ${currencySymbol}${price_max}`;
  if (price_min != null) return `from ${currencySymbol}${price_min}`;
  if (price_max != null) return `up to ${currencySymbol}${price_max}`;
  return null;
};

export const groupSlotsByDate = (slots: string[]): Record<string, string[]> => {
  const slotsByDate: Record<string, string[]> = {};
  slots.forEach((isoTimestamp) => {
    const dateKey = isoTimestamp.slice(0, 10);
    if (!slotsByDate[dateKey]) slotsByDate[dateKey] = [];
    slotsByDate[dateKey].push(isoTimestamp);
  });
  return slotsByDate;
};

export const fmtDate = (isoTimestamp: string): string =>
  new Date(isoTimestamp).toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });

export const fmtTime = (isoTimestamp: string): string =>
  new Date(isoTimestamp).toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
  });

export const formatResponseTime = (hours: number | null): string | null => {
  if (hours === null) return null;
  if (hours < 1) return 'Responds in under 1 hour';
  if (hours <= 24) return `Responds in ~${Math.round(hours)} hours`;
  return `Responds in ~${Math.round(hours / 24)} days`;
};

export type ReviewListEntry =
  | { kind: 'single'; review: Kudable.Review }
  | { kind: 'group'; groupId: string; siblings: Kudable.Review[] };

export const groupReviewsBySibling = (
  reviews: Kudable.Review[],
): ReviewListEntry[] => {
  const result: ReviewListEntry[] = [];
  const indexByGroup = new Map<string, number>();

  for (const review of reviews) {
    const groupId = review.group_review_link_id ?? null;
    if (!groupId) {
      result.push({ kind: 'single', review });
      continue;
    }
    const groupIndex = indexByGroup.get(groupId);
    if (groupIndex === undefined) {
      indexByGroup.set(groupId, result.length);
      result.push({ kind: 'group', groupId, siblings: [review] });
    } else {
      (
        result[groupIndex] as { kind: 'group'; siblings: Kudable.Review[] }
      ).siblings.push(review);
    }
  }

  return result;
};
